export default __webpack_public_path__ + "static/act_early_dc-40dd4e2ee32fbeb81b1dfbffc53624e1.svg";